import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const Section = styled.div`
  background-color: #1a1a1a;
  border-top: 2px solid #2f2f2f;
  padding: 20px 0;
  display: flex;
  justify-content: center;
  width: 100%;
`;

const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 1200px;
  width: 100%;
`;

const FooterLinks = styled.div`
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-bottom: 10px;

  a {
    color: #45a049;
    text-decoration: none;
    font-size: 1rem;
    transition: color 0.3s;

    &:hover {
      color: #3c8c42;
    }
  }
`;

const FooterText = styled.p`
  font-size: 0.9rem;
  text-align: center;
  color: #aaaaaa;
  margin: 0;
`;

const Footer = () => {
  return (
    <Section>
      <FooterContainer>
        <FooterLinks>
          <Link to="/">Privacy Policy</Link>
          <Link to="/">Terms of Service</Link>
          <Link to="/">Contact</Link>
        </FooterLinks>
        <FooterText>&copy; {new Date().getFullYear()} Pingcraft. All rights reserved.</FooterText>
      </FooterContainer>
    </Section>
  );
};

export default Footer;
